import './InitiativeSidebar.scss';
import classNames from 'classnames';
import { InitiativeSidebarStatusSelector } from './SidebarStatusSelector';
import { InitiativeTagsSection } from './InitiativeTagsSection';
import { SonarText } from '@ui/text';
import { SonarUser } from '@ui/SonarUser';
import { UserSelector } from '@ui/UserSelector';
import { coreActions } from '@sonar-software/sonar-core';
import { INITIATIVES_SIDEBAR_LABELS, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';
import { useAction, useCurrentUser } from '@hooks';
export const InitiativeSidebar = ({ assignedTo, createdBy, initiativeId, status }) => {
    const { isReadOnly } = useCurrentUser();
    const updateInitiative = useAction(coreActions.requestPatchCoreInitiativesById);
    const handleChangeOwner = useCallback((newAssignedTo) => {
        updateInitiative({
            initiativeId: initiativeId,
            patchInitiativeDescription: {
                assignedTo: newAssignedTo
            }
        });
    }, [initiativeId, updateInitiative]);
    const readOnlyClassnames = classNames({ 'read-only': isReadOnly });
    return (React.createElement("div", { className: 'initiative-sidebar' },
        React.createElement(InitiativeSidebarStatusSelector, { initiativeId: initiativeId, status: status }),
        React.createElement(SonarText, { className: 'section-header' }, INITIATIVES_SIDEBAR_LABELS.CREATED_BY),
        React.createElement(SonarUser, { avatar: true, className: 'created-by', userId: createdBy || -1 }),
        React.createElement(SonarText, { className: 'section-header' }, INITIATIVES_SIDEBAR_LABELS.OWNED_BY),
        React.createElement("div", { className: readOnlyClassnames },
            React.createElement(UserSelector, { allowClear: false, avatar: true, id: 'initiative-owner-select', onSingleChange: handleChangeOwner, placeholder: PLACEHOLDERS_COPY.ADD_OWNER, selectionRequired: true, value: assignedTo })),
        React.createElement(InitiativeTagsSection, { initiativeId: initiativeId })));
};
